<template>
  <div>
    <vx-card>
      <div class="w-full">
        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-plus" color="success" v-on:click="novo">Cadastrar novo</vs-button>
      </div>

      <div class="flex h-12 mt-6 fit-height">
        <div class="w-2/3 fit-height">
          <vs-table :data="regulamentos" class="fit-height">

            <template slot="thead">
              <vs-th>Título</vs-th>
              <vs-th>Data</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.name">
                  {{ tr.name }}
                </vs-td>
                <vs-td :data="tr.dateTime">
                  {{ tr.dateTime }}
                </vs-td>

                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-full">
                    <div class="con-btns-user flex items-center justify-between">
                      <div class="flex">
                        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-edit-2" color="warning" v-on:click="editar(indextr)">Editar</vs-button>
                        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-trash" color="danger" class="ml-4" v-on:click="remover(indextr)">Remover</vs-button>
                      </div>
                    </div>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="w-1/3 ml-10 fit-height" v-if="mostrarForm">
          <form v-on:submit.prevent="salvar" id="formulario">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" icon-pack="feather" icon="icon-star" icon-no-border label-placeholder="Título" v-model="entrada.name" />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col vs-component vs-con-input-label vs-input w-full vs-input-primary">
              <label for="" class="vs-input--label">Data</label>
              <datepicker :minimumView="'month'" :maximumView="'year'" :language="ptBR" :format="formatoData" @input="setDate" v-model='entrada.dateTime'></datepicker>
            </div>
          </div>

          <vs-upload
            automatic
            text="Enviar Regulamento"
            :action="this.$API_URL + '/upload/regulamento'"
            @on-success="successUpload"
            fileName="fotos"
            :single-upload="true"
            :multiple="false"
            />

          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/src/locale';

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      regulamentos: [],
      entrada: {
        name: '',
        reference: '',
        dateTime: ''
      },
      id: '',
      mostrarForm: false,
      index: -1,
      ptBR: ptBR
    }
  },
  methods: {
    successUpload(e){
      let resposta = JSON.parse(e.target.response).data;
      this.entrada.reference = resposta.path;
    },
    formatoData: function(date) {
      return date.toLocaleString('default', { month: 'long' }) + "/" + date.getFullYear();
    },
    setDate: function(e) {
      this.entrada.dateTime = (e.getMonth() + 1) + "/" + e.getFullYear()
    },
    novo: function() {
      this.entrada = {
        name: '',
        reference: '',
        dateTime: ''
      }
      this.index = -1;
      this.id = '';
      this.mostrarForm = true;
    },
    editar: function(index) {
      this.entrada = this.regulamentos[index];
      this.id = this.regulamentos[index]._id;
      this.index = index;
      this.mostrarForm = true;
    },
    salvar: function() {
      console.log(this.entrada);
      fetch(this.$API_URL + "/regulamento/" + this.id, {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.entrada)
      })
      .then(response => response.json())
      .then(json => {

        if (json.status == 'success') {
          this.entrada = {
            name: '',
            reference: '',
            dateTime: ''
          }

          if (this.index != -1) {
            this.regulamentos[this.index] = json.data;
          } else {
            this.regulamentos.push(json.data)
          }

          this.mostrarForm = false;
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }
      });
    },
    getRegulamentos: function() {
      fetch(this.$API_URL + "/regulamento", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        json.data.forEach(entrada => {
          this.regulamentos.push(entrada)
        })
      });
    },
    remover: function(index) {
      fetch(this.$API_URL + "/regulamento/" + this.regulamentos[index]._id, {
        method: "DELETE",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.status == "success") {
          this.regulamentos.splice(index, 1);
          this.$vs.notify({
            title:'Sucesso!',
            text:'Removido com sucesso.',
            color:'primary'})
          } else {
            this.$vs.notify({
              title:'Erro!',
              text:'Ocorreu um erro ao remover.',
              color:'danger'})
          }
      });
    }
  },
  mounted() {
    this.getRegulamentos();
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
